export default __webpack_public_path__ + "static/media/Loovers-punti-utente-senior.44973c51.png";